// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1GV5Q","consentsList":"PatientConsents_consentsList__2w6va","consentsListEmpty":"PatientConsents_consentsListEmpty__wP1ny"};